// constants
import { BOOKING_OACK_STATE_VALUE_OACK_CONFIRMED } from "@cloudspire/legacy-resources/src/constants/booking";

/**
 * Retourne vrai si la demande de confirmation propriétaire a été validée.
 */
export default function bookingIsOackStateConfirmed({ booking }) {
  return BOOKING_OACK_STATE_VALUE_OACK_CONFIRMED === booking.oackState;
}
